<template>
  <b-container fluid>
    <admin-breadcrumb name="My Account"/>
    <b-row>
      <b-col lg="4" md="5">
        <admin-panel second-body>
          <div class="mt-3 text-center">
            <b-avatar
              variant="primary"
              :src="user.avatar_url"
              :text="avatarLetters"
              size="150"
            />
            <h4 class="card-title mt-3">{{ fullName }}</h4>
            <h6 v-if="user.position" class="card-subtitle">{{ user.position }}</h6>
            <h6 v-if="user.company" class="card-subtitle">{{ user.company.name }}</h6>
          </div>
          <template v-slot:second-body>
            <small class="text-muted">Email address</small>
            <h6>{{ user.email }}</h6>
            <template v-if="user.phone">
              <small class="text-muted">Phone</small>
              <h6>{{ user.phone }}</h6>
            </template>
            <template v-if="user.date_birth">
              <small class="text-muted">Date Birth</small>
              <h6>{{ user.date_birth }}</h6>
            </template>
          </template>
        </admin-panel>
      </b-col>
      <b-col lg="8" md="7">
        <admin-panel>
          <b-form @submit.prevent="submitForm">
            <b-form-group label="First Name">
              <b-form-input
                  v-model.trim="formData.first_name"
                  type="text"
                  :state="fieldValid('first_name')"
              />
              <b-form-invalid-feedback :state="fieldValid('first_name')">
                {{ formValidation.first_name }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Last Name">
              <b-form-input
                  v-model.trim="formData.last_name"
                  type="text"
              />
              <b-form-invalid-feedback :state="fieldValid('last_name')">
                {{ formValidation.last_name }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Login">
              <b-form-input
                  v-model.trim="formData.login"
                  type="text"
              />
              <b-form-invalid-feedback :state="fieldValid('login')">
                {{ formValidation.login }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Email">
              <b-form-input
                  v-model.trim="formData.email"
                  type="text"
              />
              <b-form-invalid-feedback :state="fieldValid('email')">
                {{ formValidation.email }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Position">
              <b-form-input
                  v-model.trim="formData.position"
                  type="text"
              />
              <b-form-invalid-feedback :state="fieldValid('position')">
                {{ formValidation.position }}
              </b-form-invalid-feedback>
            </b-form-group>
<!--            <b-form-group label="Date of Birth" label-class="is-required">-->
<!--              <b-form-datepicker-->
<!--                  v-model.trim="formData.date_birth"-->
<!--                  :state="fieldValid('date_birth')"-->
<!--                  :max="maxDateBirth"-->
<!--                  locale="en-US"-->
<!--                  :hide-header="true"-->
<!--                  :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"-->
<!--                  placeholder="Pick date"-->
<!--                  nav-button-variant="primary"-->
<!--                  class="no-button"-->
<!--              ></b-form-datepicker>-->
<!--              <b-form-invalid-feedback :state="fieldValid('date_birth')">-->
<!--                {{ formValidation.date_birth }}-->
<!--              </b-form-invalid-feedback>-->
<!--            </b-form-group>-->
            <b-form-group label="Admin Notifications">
              <div v-for="(nClass, key) in adminNotificationClasses" :key="key">
                <b-form-checkbox
                    :key="key"
                    v-model="formData.notifications[nClass.class]"
                >
                  {{ nClass.name }}
                </b-form-checkbox>
              </div>
            </b-form-group>
            <span class="mb-1 d-inline-block font-italic">Leave password fields empty if you don't want to update your current password</span>
            <b-form-group label="New Password">
              <b-form-input
                  v-model.trim="formData.password"
                  type="text"
              />
              <b-form-invalid-feedback :state="fieldValid('password')">
                {{ formValidation.password }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Confirm New Password">
              <b-form-input
                  v-model.trim="formData.password_confirmation"
                  type="text"
              />
            </b-form-group>
            <b-button type="submit" variant="primary" :disabled="formState.processing">
              Update your Profile
              <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
            </b-button>
          </b-form>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminPreloader from "../components/AdminPreloader";
import {API_ROUTES} from "../api";
import AdminPanel from "../components/AdminPanel";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
export default {
  name: "AdminMyAccount",
  components: {AdminBreadcrumb, AdminPanel, AdminPreloader},
  data() {
    return {
      user: this.$store.state.auth.user,
      formData: {
        first_name: this.$store.state.auth.user.first_name,
        last_name: this.$store.state.auth.user.last_name,
        login: this.$store.state.auth.user.login,
        email: this.$store.state.auth.user.email,
        position: this.$store.state.auth.user.position,
        password: '',
        password_confirmation: '',
        // date_birth: this.$store.state.auth.user.date_birth,
        avatar_url: this.$store.state.auth.user.avatar_url,
        notifications: {}
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  methods: {
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.CURRENT_USER, this.formData).then(({data}) => {
        this.user = data.user;
        this.$store.commit('auth/setUser', data.user);
        this.$bvToast.toast('Your profile information has been successfully updated', {
          title: 'Success!',
          variant: 'success'
        });
        this.formValidation = {};
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to update your profile', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  },
  computed: {
    fullName() {
      return this.user.first_name + ' ' + this.user.last_name;
    },
    avatarLetters() {
      return this.user.first_name.substring(0, 1) + this.user.last_name.substring(0, 1);
    },
    maxDateBirth: function () {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 18);

      return date;
    },
    adminNotificationClasses() {
      return this.$store.state.data.admin_notifications;
    }
  },
  watch: {
    adminNotificationClasses(adminNotificationClasses) {
      let notifications = {};
      adminNotificationClasses.forEach(nClass => {
        notifications[nClass.class] = !(this.user.disabled_notifications && this.user.disabled_notifications.indexOf(nClass.class) >= 0);
      });
      this.formData.notifications = notifications;
    }
  }
}
</script>
